module.exports = __webpack_public_path__ + "media/components/common/images/IconChevronLeft-2f3c66a945afa2d2aaede4e61bc46983.svg";